import { Table, Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import type { FecThirdPartyMapping } from '../../../../../../types/fecThirdPartyMapping'
import { ThirdPartyTypeTag } from '../ThirdPartyTypeTag'

interface ThirdPartyTableRowProps {
  hasStatus: boolean
  mapping: FecThirdPartyMapping
}

export const ThirdPartyTableRow = ({ hasStatus, mapping }: ThirdPartyTableRowProps): ReactElement => (
  <Table.Row>
    <Table.Cell>
      <ThirdPartyTypeTag role={mapping.role} status={hasStatus ? mapping.status : undefined} />
    </Table.Cell>
    <Table.Cell>
      <Typography.Text>{mapping.accountNo}</Typography.Text>
    </Table.Cell>
    <Table.Cell>
      <Typography.Text>{mapping.label}</Typography.Text>
    </Table.Cell>
  </Table.Row>
)
